const OnbLoader = () => {
  return (
    <div className='animate-spin rounded-full h-22 w-22 border-b-2 border-positive flex flex-col justify-center items-center' />
  );
};

export default OnbLoader;
